import { createSlice } from "@reduxjs/toolkit";
import {  getExportUserList } from "../services/employee.service";
import { getManageQueries, getPlayQueryObject, queryDetail, saveQuery, searchQuery } from "../services/knowledgebase.service";

const queries:  any =  [ 
  { queryId: 1,
    queryname: 'Thank You Phrases',
     description: 'Thank you phrases Description', 
     query:'Thank you phrases AND customer service AND thank you',
      class: 'red-icon',
      daterange: 'last7days',
      startDate: null,
      endDate: null,
      isScheduled: false },
  {  queryId: 2,queryname: 'Refund Requests', description: 'Refund requests Description', query:'myQuery refund', class: 'eastern-blue-icon',
    daterange: 'last7days',
    startDate: null,
    endDate: null,
    isScheduled: false },
  {  queryId: 3,queryname: 'Identity Verification Issues', description: 'Identity verification issues Description', query:'myQuery identity', class: 'purple-icon',
    daterange: 'last7days',
    startDate: null,
    endDate: null,
    isScheduled: false },
  {  queryId: 4,queryname: 'Hold Time Analysis', description: 'Hold time analysis Description', query:'myQuery hold', class: 'yellow-icon' },]

  // Dummy data for the table
const tableData: any ={
    "status": true,
    "message": "Search completed successfully.",
    "data": {
        "next": null,
        "previous": null,
        "count": 2,
        "total_pages": 1,
        "current_page": 1,
        "results": [
            {
                "call_evaluation": {
                    "campaign": {
                        "internal_id": "7520b29b-6084-49bc-8138-261cb4b7315f",
                        "slug": "upgrades",
                        "name": "Upgrades",
                        "start_date": "2024-01-10",
                        "end_date": "2024-01-10",
                        "description": "Upgrades -multiple campaigns, changes month  to month"
                    },
                    "entity": {
                        "internal_id": "a1cc7008-7b6e-4f97-a395-1daa760e7964",
                        "name": "Getix Health",
                        "domain": 1
                    },
                    "recording": {
                        "language": null,
                        "internal_id": "80320055-3f8c-4e16-80ae-6c624448e9ab",
                        "filename": "A614A783-FBCE-EF11-816D-E8393530AAAE.mp3",
                        "filepath": "media/evaluations/recordings/2024-10-21/archive/A614A783-FBCE-EF11-816D-E8393530AAAE.mp3",
                        "call_date": "2025-02-04",
                        "call_duration": "6.15"
                    },
                    "entity_agent": {
                        "internal_id": "ef8e02b1-c079-4b97-9fd7-2a08f1bba71d",
                        "first_name": "Laura",
                        "last_name": "Sharp",
                        "associate_id": "1e79c56b"
                    },
                    "ai_score": 75,
                    "domain": {
                        "internal_id": "ac9e17ec-5fb1-4a67-b9d9-e568536d2326",
                        "name": "Healthcare"
                    },
                    "internal_id": "b2a19dd0-851c-4f5d-8fc1-b8a0b09d836d",
                    "created_on": "2024-10-22T09:19:31.840213Z",
                    "manual_score": 75
                },
                "matched_contents": [
                    {
                        "keyword": "Hello",
                        "content": "Customer: hello<br>Agent: hello good afternoon my name is this is"
                    }
                ]
            },
            {
                "call_evaluation": {
                    "campaign": {
                        "internal_id": "7520b29b-6084-49bc-8138-261cb4b7315e",
                        "slug": "collection",
                        "name": "Collection",
                        "start_date": "2024-01-10",
                        "end_date": "2024-01-10",
                        "description": "Collection -multiple campaigns, changes month  to month"
                    },
                    "entity": {
                        "internal_id": "a1cc7008-7b6e-4f97-a395-1daa760e7964",
                        "name": "Getix Health",
                        "domain": 1
                    },
                    "recording": {
                        "language": {
                            "id": "7da66bec-3102-4efa-8b84-5e7773826ac4",
                            "name": "English",
                            "code": "en"
                        },
                        "internal_id": "7f584824-c380-4a76-a93e-603a6e395d0d",
                        "filename": "558416fc-0001-b833-b1ef-0194f12de6b4.wav",
                        "filepath": "media/evaluations/recordings/2024-10-21/archive/558416fc-0001-b833-b1ef-0194f12de6b4.wav",
                        "call_date": "2025-02-11",
                        "call_duration": "6.55"
                    },
                    "entity_agent": {
                        "internal_id": "5c5ac503-8b90-4ea8-a762-e73be6d62927",
                        "first_name": "Anthony",
                        "last_name": "Barnes",
                        "associate_id": "AA2020"
                    },
                    "ai_score": 85.68,
                    "domain": {
                        "internal_id": "ac9e17ec-5fb1-4a67-b9d9-e568536d2326",
                        "name": "Healthcare"
                    },
                    "internal_id": "0ebfdba2-835b-40ee-9ceb-be8b4acf517e",
                    "created_on": "2025-02-11T10:06:51.087179Z",
                    "manual_score": 85.68
                },
                "matched_contents": [
                    {
                        "keyword": "Hello",
                        "content": "Customer: Hello.<br> Agent: Hello, Ms. Tiffrid? Melvin Hernandez?"
                    }
                ],
                "tags": [
                    "Product Inquiry",
                    "Resolved",
                    "Technical Support "
                ]
            }
        ]
    }
}

  const initialState = {
  manageQueryLoader: false,
  saveQueryLoader: false,
  exportLoader: false,
  queryDetailLoader:false,
  searchQueryLoader: false,
  exportData: [],
  listManageQueries: [],
  queryDetailData: [],
  searchQueryData : [],
  playQueryTabVar : [],
  setCurrentQueryTabData: null,
  saveQuerySuccessMsg: '',
  saveQueryErrorMsg: '',
  manageQueryErrorMsg: '',
  manageQuerySuccessMsg: '',
  exportError: '',
};

const KnowledgeBaseSlice = createSlice({
  name: "knowledge-base-list",
  initialState: initialState,
  reducers: {
    clearUserMessages: (state) => {
      // Clear all success/error messages
      state.saveQuerySuccessMsg = '';
      state.saveQueryErrorMsg = '';
      state.exportError = '';
      state.manageQueryErrorMsg = '';
      state.manageQuerySuccessMsg = '';
    },

    saveQueryTemp : (state :any, action: any) => {
      if(state.listManageQueries?.length > 0){
        state.listManageQueries = [...state.listManageQueries, action.payload];
      }else{
        state.listManageQueries = [action.payload];
      }
    },
   
    setCurrentQueryTabData: (state :any, action: any) => {
      state.currentQueryTabData = action.payload;
      let objValue =  getPlayQueryObject();
      // Transfer data for matching keys
      if(action.payload) {
        Object.keys(action?.payload || {}).forEach((key, index) => {
        if (objValue.hasOwnProperty(key)) {
          objValue[key] = action.payload[key];
        }
      });
      objValue.value = objValue.label?.replace(' ', '_').toLowerCase();
      objValue.data = tableData;
      objValue.key = objValue.label?.replace(' ', '_').toLowerCase();
       
        state.setCurrentQueryTabData = objValue;
      }
     
    },
    closeQueryTabTemp : (state :any, action) => {
      state.playQueryTabVar =  action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
     
      .addCase(getExportUserList.pending, (state, action) => {
        state.exportLoader = true;
      })
      .addCase(getExportUserList.fulfilled, (state, action) => {
        state.exportLoader = false;
        state.exportData = action.payload.results;
      })
      .addCase(getExportUserList.rejected, (state, action) => {
        state.exportLoader = false;
        state.exportError = action.error?.message || "Failed to load employee list";
      })
      //get manage queries
      .addCase(getManageQueries.pending, (state, action) => {
        state.manageQueryLoader = true;
      })
      .addCase(getManageQueries.fulfilled, (state, action: any) => {
        state.manageQueryLoader = false;
        state.listManageQueries = action.payload.results;
        state.manageQuerySuccessMsg = action.payload.message;
      })
      .addCase(getManageQueries.rejected, (state, action) => {
        state.manageQueryLoader = false;
        state.manageQueryErrorMsg = action.error?.message || "Failed to load employee list";
        state.listManageQueries = queries;
      })
      //save query
      .addCase(saveQuery.pending, (state, action) => {
        state.saveQueryLoader = true;
      })
      .addCase(saveQuery.fulfilled, (state, action) => {
        state.saveQueryLoader = false;
        state.saveQuerySuccessMsg = 'Query saved successfully';
      })
      .addCase(saveQuery.rejected, (state, action) => {
        state.saveQueryLoader = false;
        state.saveQueryErrorMsg = action.error?.message || "Failed to save query";
      })
       //Single query detail Data
       .addCase(queryDetail.pending, (state, action) => {
        state.queryDetailLoader = true;
      })
      .addCase(queryDetail.fulfilled, (state, action) => {
        state.queryDetailLoader = false;
      })
      .addCase(queryDetail.rejected, (state :any, action: any) => {
     
        state.queryDetailLoader = false;
       if(state.setCurrentQueryTabData){
        state.setCurrentQueryTabData.data = tableData?.data?.results;
        state.playQueryTabVar.push(state.setCurrentQueryTabData);
       }
      })
       //searchQuery 
       .addCase(searchQuery.pending, (state, action) => {
        state.searchQueryLoader = false;
      })
      .addCase(searchQuery.fulfilled, (state, action: any) => {
        state.searchQueryLoader = false;
        if(action.payload){
            state.searchQueryData =  action.payload.data.results
        }
      
      })
      .addCase(searchQuery.rejected, (state, action) => {
        state.searchQueryLoader = false;
      })
  },
});

export default KnowledgeBaseSlice.reducer;
export const { clearUserMessages, saveQueryTemp, setCurrentQueryTabData, closeQueryTabTemp   } = KnowledgeBaseSlice.actions;
